'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { cn } from '@achra/ui/lib/utils';
import { Popover, PopoverTrigger } from '@achra/ui/popover';
import { ArrowUpDown } from 'lucide-react';
import { type SortOptionValue, SortPopoverContent } from './popover-filter-content';
interface BudgetStatementPopoverProps {
  className?: string;
  metric: SortOptionValue;
  handleOnMetricSelect: (value: SortOptionValue) => void;
  open?: boolean;
  setOpen: (open: boolean) => void;
}
function BudgetStatementPopover(t0) {
  const $ = _c(13);
  const {
    className,
    metric,
    handleOnMetricSelect,
    open,
    setOpen
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("max-w-fit", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <PopoverTrigger asChild={true}><Button variant="ghost" className={cn("[&_path]:stroke-foreground/30 hover:[&_path]:stroke-foreground/50 active:[&_path]:stroke-foreground! h-fit p-0! font-semibold hover:bg-transparent lg:text-base/6 dark:hover:bg-transparent", "[&_path:nth-child(3)]:stroke-foreground [&_path:nth-child(4)]:stroke-foreground hover:[&_path:nth-child(3)]:stroke-foreground/50 hover:[&_path:nth-child(4)]:stroke-foreground/50 hover:[&_path:nth-child(1)]:stroke-foreground/30 hover:[&_path:nth-child(2)]:stroke-foreground/30", "[&_path:nth-child(1)]:stroke-foreground [&_path:nth-child(2)]:stroke-foreground hover:[&_path:nth-child(1)]:stroke-foreground/50 hover:[&_path:nth-child(2)]:stroke-foreground/50 hover:[&_path:nth-child(3)]:stroke-foreground/30 hover:[&_path:nth-child(4)]:stroke-foreground/30", "h-full px-4 py-2")}><ArrowUpDown className="size-4.5" /></Button></PopoverTrigger>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== handleOnMetricSelect || $[4] !== metric) {
    t3 = <SortPopoverContent metric={metric} handleOnMetricSelect={handleOnMetricSelect} />;
    $[3] = handleOnMetricSelect;
    $[4] = metric;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== open || $[7] !== setOpen || $[8] !== t3) {
    t4 = <Popover open={open} onOpenChange={setOpen}>{t2}{t3}</Popover>;
    $[6] = open;
    $[7] = setOpen;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t4) {
    t5 = <div className={t1}>{t4}</div>;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
export { BudgetStatementPopover };